
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as index4BdNpZFVCPMeta } from "/codebuild/output/src3488853854/src/pages/index.vue?macro=true";
import { default as aboutVOZsk3HdtuMeta } from "/codebuild/output/src3488853854/src/pages/about.vue?macro=true";
import { default as dataObUFC7d51VMeta } from "/codebuild/output/src3488853854/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionhqIq3hKIG2Meta } from "/codebuild/output/src3488853854/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioninguVEi0802OTMeta } from "/codebuild/output/src3488853854/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyIp4YGhAXlzMeta } from "/codebuild/output/src3488853854/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountMAxcCze2f6Meta } from "/codebuild/output/src3488853854/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statue9yrRKr7gyIMeta } from "/codebuild/output/src3488853854/src/pages/account-settings/statue.vue?macro=true";
import { default as support5Th6fbQOO2Meta } from "/codebuild/output/src3488853854/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settings5Cd1KhDexVMeta } from "/codebuild/output/src3488853854/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountxB8M4cyhX2Meta } from "/codebuild/output/src3488853854/src/pages/activate-account.vue?macro=true";
import { default as companyDjk8V4B8uEMeta } from "/codebuild/output/src3488853854/src/pages/admin/company.vue?macro=true";
import { default as consentst3j26Io32DMeta } from "/codebuild/output/src3488853854/src/pages/admin/consents.vue?macro=true";
import { default as leads3S5wllIbMCMeta } from "/codebuild/output/src3488853854/src/pages/admin/leads.vue?macro=true";
import { default as payments1WimCWQrglMeta } from "/codebuild/output/src3488853854/src/pages/admin/payments.vue?macro=true";
import { default as premium8gTKGKcXsbMeta } from "/codebuild/output/src3488853854/src/pages/admin/premium.vue?macro=true";
import { default as profilesZAMQl06aC3Meta } from "/codebuild/output/src3488853854/src/pages/admin/profiles.vue?macro=true";
import { default as userszEUsxHEUfkMeta } from "/codebuild/output/src3488853854/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordls67ii8u5VMeta } from "/codebuild/output/src3488853854/src/pages/change-password.vue?macro=true";
import { default as _91id_933LbBpfoII3Meta } from "/codebuild/output/src3488853854/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientQW1yt8VaBsMeta } from "/codebuild/output/src3488853854/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3488853854/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexrE0Nb81mJhMeta } from "/codebuild/output/src3488853854/src/pages/chat/index.vue?macro=true";
import { default as _91id_93R7ET3PM1o0Meta } from "/codebuild/output/src3488853854/src/pages/client/profile/[id].vue?macro=true";
import { default as indexakZJRLtW1bMeta } from "/codebuild/output/src3488853854/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_931ifYVAG33NMeta } from "/codebuild/output/src3488853854/src/pages/contacts/[id].vue?macro=true";
import { default as index5g1WXrno28Meta } from "/codebuild/output/src3488853854/src/pages/contacts/index.vue?macro=true";
import { default as contactsZy09fIrTXjMeta } from "/codebuild/output/src3488853854/src/pages/contacts.vue?macro=true";
import { default as _91userId_938AQD2rGw1YMeta } from "/codebuild/output/src3488853854/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexVjWgFmhaO1Meta } from "/codebuild/output/src3488853854/src/pages/login/index.vue?macro=true";
import { default as register_45successYUD3zHRVSJMeta } from "/codebuild/output/src3488853854/src/pages/login/register-success.vue?macro=true";
import { default as logind1Z2DinC24Meta } from "/codebuild/output/src3488853854/src/pages/login.vue?macro=true";
import { default as logoutpZn9jg3A8qMeta } from "/codebuild/output/src3488853854/src/pages/logout.vue?macro=true";
import { default as consentsiBajZZ030jMeta } from "/codebuild/output/src3488853854/src/pages/manager/consents.vue?macro=true";
import { default as integrationsgNgYoDykmRMeta } from "/codebuild/output/src3488853854/src/pages/manager/integrations.vue?macro=true";
import { default as leadsMbsr1bjh3jMeta } from "/codebuild/output/src3488853854/src/pages/manager/leads.vue?macro=true";
import { default as paymentsqfYHseAr5wMeta } from "/codebuild/output/src3488853854/src/pages/manager/payments.vue?macro=true";
import { default as profileMA2Kc228IGMeta } from "/codebuild/output/src3488853854/src/pages/manager/profile.vue?macro=true";
import { default as teamw22lzGOrusMeta } from "/codebuild/output/src3488853854/src/pages/manager/team.vue?macro=true";
import { default as index5MJbwewGQnMeta } from "/codebuild/output/src3488853854/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clienthEKpWvsGUnMeta } from "/codebuild/output/src3488853854/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplace71zcJ3cuwWMeta } from "/codebuild/output/src3488853854/src/pages/marketplace.vue?macro=true";
import { default as subscribeUjFtMWvHg3Meta } from "/codebuild/output/src3488853854/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientUJHD1ObpYaMeta } from "/codebuild/output/src3488853854/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clienteZ2Qlr67tMMeta } from "/codebuild/output/src3488853854/src/pages/orders/my.client.vue?macro=true";
import { default as privacy2QVxnLX2DbMeta } from "/codebuild/output/src3488853854/src/pages/privacy.vue?macro=true";
import { default as indexmw6BY6EvihMeta } from "/codebuild/output/src3488853854/src/pages/recover/index.vue?macro=true";
import { default as successhrMbgRWFnvMeta } from "/codebuild/output/src3488853854/src/pages/register/success.vue?macro=true";
import { default as _91id_93p1LfnLAL26Meta } from "/codebuild/output/src3488853854/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexijAV3F205IMeta } from "/codebuild/output/src3488853854/src/pages/sales/profile/index.vue?macro=true";
import { default as statuetmDJl5TttqMeta } from "/codebuild/output/src3488853854/src/pages/statue.vue?macro=true";
import { default as successmwpx8b3kgsMeta } from "/codebuild/output/src3488853854/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubQr0biJ2MXZMeta } from "/codebuild/output/src3488853854/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQr0biJ2MXZ } from "/codebuild/output/src3488853854/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index4BdNpZFVCPMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutVOZsk3HdtuMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutVOZsk3HdtuMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settings5Cd1KhDexVMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settings5Cd1KhDexVMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3488853854/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountxB8M4cyhX2Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountxB8M4cyhX2Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyDjk8V4B8uEMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyDjk8V4B8uEMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentst3j26Io32DMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentst3j26Io32DMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads3S5wllIbMCMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads3S5wllIbMCMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: payments1WimCWQrglMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: payments1WimCWQrglMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premium8gTKGKcXsbMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premium8gTKGKcXsbMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesZAMQl06aC3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesZAMQl06aC3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userszEUsxHEUfkMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userszEUsxHEUfkMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordls67ii8u5VMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordls67ii8u5VMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_933LbBpfoII3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_933LbBpfoII3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientQW1yt8VaBsMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientQW1yt8VaBsMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexrE0Nb81mJhMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexrE0Nb81mJhMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93R7ET3PM1o0Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93R7ET3PM1o0Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexakZJRLtW1bMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexakZJRLtW1bMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/client/profile/index.vue")
  },
  {
    name: contactsZy09fIrTXjMeta?.name,
    path: "/en/contacts",
    meta: contactsZy09fIrTXjMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_931ifYVAG33NMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: index5g1WXrno28Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsZy09fIrTXjMeta?.name,
    path: "/pl/contacts",
    meta: contactsZy09fIrTXjMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_931ifYVAG33NMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: index5g1WXrno28Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_938AQD2rGw1YMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_938AQD2rGw1YMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index4BdNpZFVCPMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: index4BdNpZFVCPMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/index.vue")
  },
  {
    name: logind1Z2DinC24Meta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3488853854/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexVjWgFmhaO1Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successYUD3zHRVSJMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: logind1Z2DinC24Meta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3488853854/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexVjWgFmhaO1Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successYUD3zHRVSJMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutpZn9jg3A8qMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutpZn9jg3A8qMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsiBajZZ030jMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsiBajZZ030jMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsgNgYoDykmRMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsgNgYoDykmRMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsMbsr1bjh3jMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsMbsr1bjh3jMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsqfYHseAr5wMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsqfYHseAr5wMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileMA2Kc228IGMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileMA2Kc228IGMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamw22lzGOrusMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamw22lzGOrusMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/manager/team.vue")
  },
  {
    name: marketplace71zcJ3cuwWMeta?.name,
    path: "/en/marketplace",
    meta: marketplace71zcJ3cuwWMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3488853854/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clienthEKpWvsGUnMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplace71zcJ3cuwWMeta?.name,
    path: "/pl/marketplace",
    meta: marketplace71zcJ3cuwWMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3488853854/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clienthEKpWvsGUnMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeUjFtMWvHg3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeUjFtMWvHg3Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientUJHD1ObpYaMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientUJHD1ObpYaMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clienteZ2Qlr67tMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clienteZ2Qlr67tMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3488853854/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacy2QVxnLX2DbMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacy2QVxnLX2DbMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexmw6BY6EvihMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexmw6BY6EvihMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3488853854/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3488853854/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93p1LfnLAL26Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93p1LfnLAL26Meta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexijAV3F205IMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexijAV3F205IMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuetmDJl5TttqMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuetmDJl5TttqMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successmwpx8b3kgsMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successmwpx8b3kgsMeta || {},
    component: () => import("/codebuild/output/src3488853854/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubQr0biJ2MXZMeta?.name,
    path: "/old-page",
    component: component_45stubQr0biJ2MXZ
  }
]